export default __webpack_public_path__ + "static/media/tripleImgMobile.04b925cb.png";